import React from 'react';
import PropTypes from 'prop-types';

/**
 * HeroCard Component
 *
 * Large hero card with gradient background for dashboard states
 * Used at the top of each dashboard state to communicate current status
 *
 * Props:
 * - emoji: Emoji icon to display
 * - title: Main title text
 * - subtitle: Subtitle/description text
 * - variant: Color theme (default, success, warning)
 */
function HeroCard({ emoji, title, subtitle, variant = 'default' }) {
  const variantStyles = {
    default: 'bg-gradient-to-br from-[#556B2F] to-[#6B8E23]',
    success: 'bg-gradient-to-br from-green-600 to-green-500',
    warning: 'bg-gradient-to-br from-red-600 to-red-500',
  };

  return (
    <div
      className={`
        ${variantStyles[variant]}
        rounded-3xl p-8 text-white text-center mb-6
        shadow-lg
      `}
    >
      <div className="text-6xl mb-4">{emoji}</div>
      <h1 className="text-3xl font-bold mb-3">{title}</h1>
      <p className="text-xl opacity-90">{subtitle}</p>
    </div>
  );
}

HeroCard.propTypes = {
  emoji: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(['default', 'success', 'warning'])
};

export default HeroCard;
